import AlertSuccessIcon from "@/assets/svgs/alert-success-icon";
import WarningIcon from "@/assets/svgs/warning-icon";
import { Text, View } from "react-native";
import { useSlot, useStyled } from "use-styled";

const AlertRoot = useStyled(View, {
  base: {
    className: "px-4 py-3 flex-row items-center rounded-2xl",
  },
  variants: {
    size: {
      sm: { className: "rounded-[8] gap-2" },
      md: { className: "rounded-[11] gap-3" },
    },
    type: {
      warning: { className: "bg-orange-100" },
      success: { className: "bg-green-100" },
    },
  },
  defaultVariants: {},
  compoundVariants: [],
});

const AlertBox = useStyled(View, {
  base: {
    className: "flex-1 items-start",
  },
  variants: {},
  defaultVariants: {},
});

const AlertTitle = useStyled(Text, {
  base: {
    className: "font-geologica-medium font-medium text-gray-700 text-base leading-[1.5]",
  },
  variants: {},
  defaultVariants: {},
});

const AlertSubTitle = useStyled(Text, {
  base: {
    className: "font-geologica-regular text-gray-700 text-xl leading-[1.5]",
  },
  variants: {},
  defaultVariants: {},
});

const AlertIcon = useStyled(View, {
  base: {
    className: "me-3",
  },
  variants: {
    type: {
      warning: {
        children: <WarningIcon className="fill-orange-500 size-6" />,
      },
      success: {
        children: <AlertSuccessIcon className="fill-green-500 size-6" />,
      },
    },
  },
  defaultVariants: {},
});

export const Alert = useSlot(AlertRoot, {
  Title: AlertTitle,
  SubTitle: AlertSubTitle,
  Icon: AlertIcon,
  Box: AlertBox,
});
